'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeCarpetIcon = function TraceTypeCarpetIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement(
            'g',
            { fill: 'none' },
            _react2.default.createElement('path', { d: 'M0 0h46v46H0z' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M41.5 16.469l-8.745 8.887-4.71 7.858-4.709 3.418-8.745-5.468L4.5 29.796l5.382-4.101 4.036-7.176 9.418-8.887 8.073 4.786L41.5 16.469z', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M28.045 33.214l-9.418-5.468-8.745-2.051m22.873-.339l-9.419-3.419-9.418-3.418', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' }),
            _react2.default.createElement('path', { stroke: '#1d9bfb', d: 'M14.591 31.164l4.036-3.418 4.709-5.809 8.073-7.519', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })
        )
    );
};

exports.default = TraceTypeCarpetIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeCarpetIcon.js
// module id = 707
// module chunks = 0